export function bgImageFilter() {
  return ( src: string ): string => {
    return src ? `url(${src})` : '';
  };
}



// WEBPACK FOOTER //
// ./app/shared/filters/bg-image.filter.ts